export const POSSIBLE_EXT_LIST = [
    'jpg',
    'jpeg',
    'gif',
    'bmp',
    'png',
    'mpg',
    'mpeg',
    'mp4',
    'mp3',
    'wav',
    'doc',
    'docx',
    'hwp',
    'txt',
    'pdf',
    'csv',
    'xls',
    'xlsx',
    'ppt',
    'pptx',
    'zip',
    'svg',
];
export const FILE_MAX_SIZE = 15;
export const NO_FILE = 'noFile';
export const NO_EXT_FILE = 'noExtFile';
export const EMPTY_FILE = 'emptyFile';
export const MAX_FILE = 'maxFile';
export const OK_FILE = 'okFile';
export const EXT_STRING = 'jpg, jpeg, gif, bmp, png, mpg, mpeg, mp4, mp3, wav, doc, docx, hwp, txt, pdf, csv, xls, xlsx, ppt, pptx, zip, svg';
export const getChatSize = () => {
    const width = typeof window !== 'undefined' ? window.innerWidth : 1920;
    const height = typeof window !== 'undefined' ? window.innerHeight : 1080;
    if (width >= 1200 && height >= 800)
        return 80; // Desktop
    if (width >= 768)
        return 40; // Tablet
    if (width < 768)
        return 30; // Mobile
    return 40; // Default
};
export const getApiChatSize = () => {
    const width = typeof window !== 'undefined' ? window.innerWidth : 1920;
    const height = typeof window !== 'undefined' ? window.innerHeight : 1080;
    if (width >= 1200 && height >= 800)
        return 30; // Desktop
    if (width >= 768)
        return 15; // Tablet
    if (width < 768)
        return 10; // Mobile
    return 20; // Default
};
